import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/plan/paymentFundsSummary.scss';
import { AccordionSection } from '../ui/accordian/accordianSection';
import AccordianSectionHeader from '../ui/accordian/accordianSectionHeader';
import AccordianSectionBody from '../ui/accordian/accordianSectionBody';
import { Accordion } from '../ui/accordian/accordian';

interface Props {
  onEdit: any;
  cart: any;
  hideEdit: any;
}

const FundList = ({ cart }: Props) => {
  return (
    <div className={cx(styles['funds-list'], 'mb15')}>
      <Accordion type="custom" selected="fund_list">
        <AccordionSection>
          <AccordianSectionHeader>
            <div className={'clearfix font--black text--uppercase'}>
              <span>Funds you are investing in:</span>
              <div className={'inline-block ml15'}>
                {cart &&
                  cart.items &&
                  cart.items.map((fund: any) => (
                    <div
                      className={styles['fund-item-collapse']}
                      key={fund.product.referProduct.fundName}
                    >
                      <img
                        src={`${CDN_CLRSAVE_URL}/clearsave${fund.product.referProduct.imageUrl}`}
                        alt="bank"
                      />
                    </div>
                  ))}
              </div>
            </div>
          </AccordianSectionHeader>
          <AccordianSectionBody className="ml10">
            <ul className={'lil-flex'}>
              {cart &&
                cart.items &&
                cart.items.map((fund: any) => (
                  <li
                    className={styles['fund-item']}
                    key={fund.product.referProduct.fundName}
                  >
                    <img
                      src={`${CDN_CLRSAVE_URL}/clearsave${fund.product.referProduct.imageUrl}`}
                      alt="bank"
                      className={cx(styles['fund-img'], 'mb5')}
                    />
                    <p className={cx('text--sm ml5 mr5')}>
                      {fund.product.referProduct.fundName}
                    </p>
                  </li>
                ))}
            </ul>
          </AccordianSectionBody>
        </AccordionSection>
      </Accordion>
    </div>
  );
};

export default FundList;



// WEBPACK FOOTER //
// ./components/payment/fundList.tsx